import { makeStyles } from "@material-ui/core";
import { Link } from "react-router-dom";

interface ILinkField {
  record: any;
}

const useStyles = makeStyles({
  root: {
    textDecoration: "none",
    color: "#3f51b5",
  },
});

const ParentLinkField = ({ record }: ILinkField) => {
  const classes = useStyles();

  return (
    <Link
      to={`/parents/${record.parent?.id}/show`}
      target="_blank"
      rel="noopener noreferrer"
      className={classes.root}
    >
      {`${record.parent?.firstName} ${record.parent?.lastName} - ${record.parent?.mobile}`}
    </Link>
  );
};

export default ParentLinkField;
